import { render, staticRenderFns } from "./PhotosCarouselItem.vue?vue&type=template&id=a6c41224&scoped=true"
import script from "./PhotosCarouselItem.vue?vue&type=script&lang=js"
export * from "./PhotosCarouselItem.vue?vue&type=script&lang=js"
import style0 from "./PhotosCarouselItem.vue?vue&type=style&index=0&id=a6c41224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c41224",
  null
  
)

export default component.exports